import { render, staticRenderFns } from "./ContentModeSwitch.vue?vue&type=template&id=4b5d6923&scoped=true"
import script from "./ContentModeSwitch.vue?vue&type=script&lang=ts"
export * from "./ContentModeSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ContentModeSwitch.vue?vue&type=style&index=0&id=4b5d6923&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d6923",
  null
  
)

export default component.exports